// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__21AgU","logo":"Sidebar_logo__3xA_6"};